import VerticalLayout from './VerticalLayout';

export default VerticalLayout;
export * from './VerticalLayout';
